import NsContent from 'components/common/ns-content/NsContent';

import { NsList } from 'components/common/ns-list/NsList';

export const testId = 'agreementTestId';

type AgreementProps = {
  isTOU: boolean;
};

export const Agreement = ({ isTOU }: AgreementProps) => {
  return (
    <NsContent data-testid={testId}>
      {isTOU ? (
        <>
          <p>
            By pressing <b>‘Complete order’</b>,
          </p>
          <p>
            You&apos;re happy with the privacy policy and for your smart
            meter(s) to send half hourly readings. For more details refer to our
            privacy policy below.
          </p>
          <NsList className="ul-bullet">
            {[
              `Your smart meter readings will be collected every half-hour.`,
              `This can help manage your energy usage, potentially cutting costs.`,
              `We may use half-hourly data to offer you tailored energy products 
                and services.`,
              `If you switch tariffs, we’ll still collect readings every half-hour. 
                You can change your meter reading frequency at any time in your 
                online account. However, you may no longer be eligible for this 
                tariff.`
            ]}
          </NsList>
          <p>You agree to enter into a contract for a new energy tariff.</p>
        </>
      ) : (
        <p>
          By pressing <b>‘Complete order’</b> you agree to enter into a contract
          for a new energy tariff.
        </p>
      )}

      <p>
        You have <b>14 calendar days from tomorrow</b> if you wish to change
        your mind.
      </p>
    </NsContent>
  );
};
